import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { RxFor } from '@rx-angular/template/for';
import { NgxPopperjsModule } from 'ngx-popperjs';
import { NgScrollbar, NgScrollbarModule } from 'ngx-scrollbar';

import { DropdownComponent } from './dropdown.component';

@NgModule({
    imports: [CommonModule, AutomationModule, NgxPopperjsModule, NgScrollbarModule, RxFor, IconCustomComponent],
    exports: [DropdownComponent],
    declarations: [DropdownComponent],
    providers: [NgScrollbar],
})
export class DropdownModule {}
